
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Watermark from './components/Watermark';

// App.js or Layout.js
const isDemo = true; // Toggle this conditionally if needed (e.g., from env or user role)

const AppLayout = ({ children }) => (
  <div style={{ position: 'relative' }}>
    <Watermark show={isDemo} />
    {children}
  </div>
);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppLayout>
    <App />
    </AppLayout>
  </React.StrictMode>
);

reportWebVitals();

